import { Box, styled } from '@withjoy/joykit';

export const CheckboxContainer = styled(Box)`
  input:checked + label .checkbox_svg__check-circle {
    fill: ${props => props.theme.colors.mono14};
    stroke: ${props => props.theme.colors.mono14};
  }
`;
